<template>
  <window-portal :open="dataProps.show" @close="onClose">
    <preview-document
      :config="previewConfig"
      :send-email="!hideQr"
      :download-json="!hideQr"
      @clickSendEmail="sendEmail"
      @clickDownloadJson="downLoadJSON"
      :mail-label="mailLabel"
    >
      <template #tools>
        <download-invalidation-json :header="dataProps.data.header" />
      </template>
      <template #pages="{ config }">
        <preview-page
          v-for="(pageData, pIndex) in pagesData"
          :key="`page-${pIndex}`"
          :config="config"
        >
          <!-- page-header -->
          <template #header>
            <!-- Encabezado factura -->
            <div
              style="
                display: flex;
                justify-content: space-between;
                border: 1px solid black;
                font-size: 10pt;
              "
            >
              <div
                style="
                  border-right: 1px solid black;
                  padding: 2px;
                  width: 340px;
                "
              >
                <div>
                  <template v-if="dataProps.data.header.ID_Branch === '115'">
                    <img
                      v-if="
                        dataProps.data.branch?.BranchLogoPath != null &&
                        dataProps.data.branch?.BranchLogoPath != '' &&
                        dataProps.data.branch?.BranchLogoPath != 'null'
                      "
                      style="
                        max-width: 330px !important;
                        height: auto;
                        max-height: 100px !important;
                      "
                      :src="dataProps.data.branch.BranchLogoPath"
                    />
                  </template>
                  <template v-else>
                    <img
                      v-if="
                        dataProps.data.branch?.BranchLogoPath != null &&
                        dataProps.data.branch?.BranchLogoPath != '' &&
                        dataProps.data.branch?.BranchLogoPath != 'null'
                      "
                      style="
                        max-width: 300px !important;
                        height: auto;
                        max-height: 100px !important;
                      "
                      :src="dataProps.data.branch.BranchLogoPath"
                    />
                  </template>
                </div>
                <div v-html="modifiedBranchBilledInfo"></div>
                <div>NIT: {{ dataProps.data.branch.BusinessBillingNIT }}</div>
                <div>NRC: {{ dataProps.data.branch.BusinessBillingNRC }}</div>
              </div>
              <div style="flex-grow: 1">
                <div
                  :style="`background-color: ${colorTable.bg}; color: ${colorTable.fg}; text-align: center; padding: 5px 0px`"
                >
                  <span>{{
                    dataProps.data.header.InvoiceType == "FCF"
                      ? "FACTURA CONSUMIDOR FINAL"
                      : ""
                  }}</span>
                  <span>{{
                    dataProps.data.header.InvoiceType == "CCF"
                      ? "COMPROBANTE DE CRÉDITO FISCAL"
                      : ""
                  }}</span>
                  <span>{{
                    dataProps.data.header.InvoiceType == "FNS"
                      ? "FACTURA SUJETO EXCLUIDO"
                      : ""
                  }}</span>
                  <span>{{
                    dataProps.data.header.InvoiceType == "FEX"
                      ? "FACTURA DE EXPORTACIÓN"
                      : ""
                  }}</span>
                  <span>{{
                    dataProps.data.header.InvoiceType == "DNC"
                      ? "NOTA DE CRÉDITO"
                      : ""
                  }}</span>
                  <span>{{
                    dataProps.data.header.InvoiceType == "DND"
                      ? "NOTA DE DÉBITO"
                      : ""
                  }}</span>
                  <span>{{
                    dataProps.data.header.InvoiceType == "CDD"
                      ? "COMPROBANTE DE DONACIÓN"
                      : ""
                  }}</span>
                  <span>{{
                    dataProps.data.header.InvoiceType == "DNR"
                      ? "NOTA DE REMISIÓN"
                      : ""
                  }}</span>
                </div>
                <div style="padding-left: 10px; padding-bottom: 4px">
                  <b>Código generación: </b
                  >{{ dataProps.data.header.CodigoGeneracion }}
                </div>
                <div style="padding-left: 10px; padding-bottom: 4px">
                  <b>Sello de recepción: </b
                  >{{ dataProps.data.header.SelloRecepcion }}
                </div>
                <div style="padding-left: 10px; padding-bottom: 4px">
                  <b>Número de control: </b
                  >{{ dataProps.data.header.NumeroControl }}
                </div>
                <div
                  v-if="
                    dataProps.data.header.InvoiceStatusDescription ==
                    'Cancelada'
                  "
                  style="padding-left: 10px; padding-bottom: 4px"
                >
                  <b>Fecha emisión: </b>{{ dataProps.data.header.InvoiceDate }}
                </div>
                <template v-else>
                  <div style="padding-left: 10px; padding-bottom: 4px">
                    <b>Fecha emisión: </b
                    >{{ dataProps.data.header.InvoiceDate }}
                  </div>
                  <div style="padding-left: 10px; padding-bottom: 4px">
                    <b>Fecha vencimiento: </b>{{ dateWithDays }}
                  </div>
                </template>
                <div style="padding-left: 10px; padding-bottom: 4px">
                  <b>Correlativo factura: </b
                  >{{ dataProps.data.header.ID_Invoice }}
                </div>
                <template v-if="ShowCorrelativeControl">
                  <div style="padding-left: 10px; padding-bottom: 4px">
                    <b>Correlativo interno: </b
                    >{{
                      dataProps.data.header.InvoiceType +
                      "-" +
                      dataProps.data.header.Correlative_ID_Invoice
                    }}
                  </div>
                </template>
                <div style="text-align: center">
                  <img v-if="!hideQr" ref="qrcode" :src="urlQr" />
                </div>
                <table
                  style="
                    font-size: 10pt;
                    border-collapse: collapse;
                    width: 100%;
                    border-top: 1px solid black;
                    margin-top: 5px;
                  "
                >
                  <tr>
                    <td
                      style="
                        padding-left: 10px;
                        padding-right: 10px;
                        text-align: left;
                      "
                    >
                      <b>Modelo de facturación:</b>
                    </td>
                    <td
                      style="
                        padding-left: 10px;
                        padding-right: 10px;
                        text-align: left;
                      "
                      v-if="
                        dataProps.data.dteJson.IdentificacionTipoModelo == 1
                      "
                    >
                      Previo
                    </td>
                    <td
                      style="
                        padding-left: 10px;
                        padding-right: 10px;
                        text-align: left;
                      "
                      v-if="
                        dataProps.data.dteJson.IdentificacionTipoModelo == 2
                      "
                    >
                      Diferido
                    </td>
                    <td
                      style="
                        padding-left: 10px;
                        padding-right: 10px;
                        text-align: left;
                      "
                    >
                      <b>Tipo de transmisión:</b>
                    </td>
                    <td
                      style="
                        padding-left: 10px;
                        padding-right: 10px;
                        text-align: left;
                      "
                      v-if="
                        dataProps.data.dteJson.IdentificacionTipoOperacion == 1
                      "
                    >
                      Normal
                    </td>
                    <td
                      style="
                        padding-left: 10px;
                        padding-right: 10px;
                        text-align: left;
                      "
                      v-if="
                        dataProps.data.dteJson.IdentificacionTipoOperacion == 2
                      "
                    >
                      Por contingencía
                    </td>
                  </tr>
                  <tr></tr>
                </table>
              </div>
            </div>
            <!-- Detalle factura -->
            <div
              style="
                border-left: 1px solid black;
                border-right: 1px solid black;
              "
            >
              <table
                style="font-size: 10pt; border-collapse: collapse; width: 100%"
              >
                <tr>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    <b>Código Cliente:</b>
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    {{ dataProps.data.header.ID_Customer }}
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    <b>Razón Social:</b>
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    {{ dataProps.data.header.InvoiceName }}
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    <b>NIT:</b>
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    {{ dataProps.data.header.InvoiceNIT || "---" }}
                  </td>
                </tr>

                <tr>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    <b>Departamento:</b>
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    {{ dataProps.data.header.ClienteDepartamento }}
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    <b>Municipio:</b>
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    {{ dataProps.data.header.ClienteMunicipio }}
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    <b>Dirección:</b>
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    {{ dataProps.data.header.InvoiceAddress }}
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    <b>Telefono fijo:</b>
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    {{
                      dataProps.data.header.ClienteTelefonoFijoDeContacto ||
                      "---"
                    }}
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    <b>Telefono movil:</b>
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    {{
                      dataProps.data.header.ClienteTelefonoMovilDeContacto ||
                      "---"
                    }}
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    <b>Correo Electrónico:</b>
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    {{ dataProps.data.header.correo || dataProps.data.header?.customerInfo?.Email || dataProps.data.header?.customerInfo?.BusinessEmail || "---" }}
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    <b>NRC:</b>
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    {{ dataProps.data.header.InvoiceNRC || "---" }}
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    <b>DUI:</b>
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    {{ dataProps.data.header.InvoiceDUI || "---" }}
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    <b>Actividad Económica:</b>
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    {{ dataProps.data.dteJson.ReceptorDescActividad || "---" }}
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    <b>Condición de pago:</b>
                  </td>
                  <td
                    style="
                      padding-left: 10px;
                      padding-right: 10px;
                      padding-bottom: 5px;
                    "
                  >
                    {{
                      dataProps.data.header.InvoiceStatusDescription ==
                      "Cancelada"
                        ? "Al Contado"
                        : dataProps.data.header.InvoiceStatusDescription
                    }}
                  </td>
                </tr>
              </table>
              <!-- tabla facturas tipo DNC y DND -->
              <div
                v-if="
                  dataProps.data.header.InvoiceType == 'DNC' ||
                  dataProps.data.header.InvoiceType == 'DND'
                "
                style="padding: 5px"
              >
                <table
                  style="
                    width: 100% !important;
                    font-size: 11px;
                    border-collapse: collapse;
                    border: 1px solid black;
                  "
                >
                  <tr style="background: gray">
                    <td colspan="3" style="text-align: center; color: white">
                      DOCUMENTOS RELACIONADOS
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="border: 1px solid; padding-left: 2px; width: 35px"
                    >
                      Tipo de Documento
                    </td>
                    <td
                      style="border: 1px solid; padding-left: 2px; width: 35px"
                    >
                      Nº de Documento
                    </td>
                    <td
                      style="border: 1px solid; padding-left: 2px; width: 35px"
                    >
                      Fecha de Documento
                    </td>
                  </tr>

                  <tr
                    v-for="(item, index) in dataProps.data.docRelated"
                    :key="index"
                  >
                    <td style="border-left: 1px solid; border-right: 1px solid">
                      {{
                        item.TipoDocumentoRelacionado == "03"
                          ? "Comprobante de Crédito Fiscal"
                          : ""
                      }}
                    </td>
                    <td style="border-left: 1px solid; border-right: 1px solid">
                      {{ item.NumeroDocumentoRelacionado }}
                    </td>
                    <td style="border-left: 1px solid; border-right: 1px solid">
                      {{ item.FechaEmisionRelacionado }}
                    </td>
                  </tr>
                </table>
              </div>
              <!-- tabla para facturas tipo CDD -->
              <div
                v-if="dataProps.data.header.InvoiceType == 'CDD'"
                style="padding: 5px"
              >
                <table
                  style="
                    width: 100% !important;
                    font-size: 11px;
                    border-collapse: collapse;
                    border: 1px solid black;
                  "
                >
                  <tr style="background: gray">
                    <td colspan="3" style="text-align: center; color: white">
                      DOCUMENTOS RELACIONADOS
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="border: 1px solid; padding-left: 2px; width: 35px"
                    >
                      Documento Asociado
                    </td>
                    <td
                      style="border: 1px solid; padding-left: 2px; width: 35px"
                    >
                      Nº Documento Asociado
                    </td>
                    <td
                      style="border: 1px solid; padding-left: 2px; width: 35px"
                    >
                      Descripción
                    </td>
                  </tr>

                  <tr>
                    <td style="border-left: 1px solid; border-right: 1px solid">
                      {{ dataProps.data.dteJson.OtrosDocumentosCodDocAsociado }}
                    </td>
                    <td style="border-left: 1px solid; border-right: 1px solid">
                      {{ dataProps.data.dteJson.OtrosDocumentosDescDocumento }}
                    </td>
                    <td style="border-left: 1px solid; border-right: 1px solid">
                      {{
                        dataProps.data.dteJson.OtrosDocumentosDetalleDocumento
                      }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <!-- Encabezados tabla de productos/servicios -->
            <table
              style="
                width: 100% !important;
                font-size: 11px;
                border-collapse: collapse;
                border: 1px solid black;
              "
            >
              <colgroup>
                <col style="width: 40px" />
                <col style="width: 40px" />
                <col style="width: 40px" />
                <col style="width: 115px" />
                <col />
                <col style="width: 70px" />
                <col style="width: 69px" />
                <col style="width: 70px" />
                <col style="width: 70px" />
                <col
                  v-if="
                    dataProps.data.header.InvoiceType != 'FEX' &&
                    dataProps.data.header.InvoiceType != 'CDD'
                  "
                  style="width: 70px"
                />
              </colgroup>
              <tr
                :style="`background-color: ${colorTable.bg}; color: ${colorTable.fg};`"
              >
                <th colspan="11" style="text-align: center">
                  CUERPO DEL DOCUMENTO
                </th>
              </tr>
              <tr>
                <th style="border: 1px solid; padding-left: 2px">
                  No.<br />Item
                </th>
                <th style="border: 1px solid; padding-left: 2px">
                  Tipo<br />Item
                </th>
                <th style="border: 1px solid; padding-left: 2px">
                  Cant.
                </th>
                <th style="border: 1px solid; padding-left: 2px">
                  Código
                </th>
                <th style="border: 1px solid; padding-left: 2px">
                  Descripción
                </th>
                <th style="border: 1px solid; padding-left: 2px">
                  Precio<br />unitario
                  {{ dataProps.data.header.InvoiceCurrency }}
                </th>
                <th
                  v-if="dataProps.data.header.InvoiceType != 'CDD'"
                  style="border: 1px solid; padding-left: 2px"
                >
                  Descuento {{ dataProps.data.header.InvoiceCurrency }}
                </th>
                <th
                  v-if="
                    dataProps.data.header.InvoiceType != 'FEX' &&
                    dataProps.data.header.InvoiceType != 'CDD'
                  "
                  style="border: 1px solid; padding-left: 2px"
                >
                  Ventas<br />exentas
                  {{ dataProps.data.header.InvoiceCurrency }}
                </th>
                <th
                  v-if="
                    dataProps.data.header.InvoiceType != 'FEX' &&
                    dataProps.data.header.InvoiceType != 'CDD'
                  "
                  style="border: 1px solid; padding-left: 2px"
                >
                  Ventas no<br />sujetas
                  {{ dataProps.data.header.InvoiceCurrency }}
                </th>
                <th
                  v-if="
                    dataProps.data.header.InvoiceType == 'FEX' &&
                    dataProps.data.header.InvoiceType != 'CDD'
                  "
                  style="border: 1px solid; padding-left: 2px"
                >
                  Otros montos no afectos
                  {{ dataProps.data.header.InvoiceCurrency }}
                </th>
                <th
                  v-if="
                    dataProps.data.header.InvoiceType != 'FEX' &&
                    dataProps.data.header.InvoiceType != 'CDD'
                  "
                  style="border: 1px solid; padding-left: 2px"
                >
                  Ventas <br />gravadas
                  {{ dataProps.data.header.InvoiceCurrency }}
                </th>
                <th
                  v-if="dataProps.data.header.InvoiceType == 'FEX'"
                  style="border: 1px solid; padding-left: 2px"
                >
                  Ventas <br />afectas
                  {{ dataProps.data.header.InvoiceCurrency }}
                </th>
                <th
                  v-if="dataProps.data.header.InvoiceType == 'CDD'"
                  style="border: 1px solid; padding-left: 2px"
                >
                  Valor <br />donado {{ dataProps.data.header.InvoiceCurrency }}
                </th>
              </tr>
            </table>
          </template>
          <!-- page body -->
          <div>
            <!-- tabla factura -->
            <div>
              <table
                style="
                  width: 100% !important;
                  font-size: 11px;
                  border-collapse: collapse;
                  border-bottom: 1px solid black;
                "
              >
                <colgroup>
                  <col style="width: 40px" />
                  <col style="width: 40px" />
                  <col style="width: 40px" />
                  <col style="width: 115px" />
                  <col />
                  <col style="width: 70px" />
                  <col style="width: 69px" />
                  <col style="width: 70px" />
                  <col style="width: 70px" />
                  <col
                    v-if="
                      dataProps.data.header.InvoiceType != 'FEX' &&
                      dataProps.data.header.InvoiceType != 'CDD'
                    "
                    style="width: 70px"
                  />
                </colgroup>
                <tr
                  v-for="(row, rIndex) in pageData"
                  :key="`row-${pIndex}-${rIndex}`"
                  style="height: 40px"
                >
                  <td
                    style="
                      border-left: 1px solid;
                      border-right: 1px solid;
                      padding: 5px;
                    "
                    v-html="row.index"
                  ></td>
                  <td
                    style="
                      border-left: 1px solid;
                      border-right: 1px solid;
                      padding: 5px;
                    "
                    v-if="keyMaster !== '7578075a2716744af3f61bdc24037bf7'"
                  >
                    {{ row.itemType }}
                  </td>
                  <td
                    style="
                      border-left: 1px solid;
                      border-right: 1px solid;
                      padding: 5px;
                    "
                  >
                    {{ row.ItemQuantity }}
                  </td>
                  <td
                    style="
                      border-left: 1px solid;
                      border-right: 1px solid;
                      padding: 5px;
                    "
                  >
                    {{ row.ID_Item }}
                  </td>
                  <td
                    style="
                      border-left: 1px solid;
                      border-right: 1px solid;
                      padding: 5px;
                      word-break: break-word;
                    "
                  >
                    {{ row.ItemDescription }}
                  </td>
                  <td
                    style="
                      border-left: 1px solid;
                      border-right: 1px solid;
                      text-align: right;
                      padding: 5px;
                    "
                  >
                    {{
                      formatWithCommas(parseFloat(row.ItemUnitPrice).toFixed(2))
                    }}
                  </td>
                  <td
                    v-if="dataProps.data.header.InvoiceType != 'CDD'"
                    style="
                      border-left: 1px solid;
                      border-right: 1px solid;
                      text-align: right;
                      padding: 5px;
                    "
                  >
                    {{
                      formatWithCommas(parseFloat(row.ItemDiscount).toFixed(2))
                    }}
                  </td>
                  <td
                    v-if="
                      dataProps.data.header.InvoiceType != 'FEX' &&
                      dataProps.data.header.InvoiceType != 'CDD'
                    "
                    style="
                      border-left: 1px solid;
                      border-right: 1px solid;
                      text-align: right;
                      padding: 5px;
                    "
                  >
                    {{
                      formatWithCommas(parseFloat(row.ItemExenta).toFixed(2))
                    }}
                  </td>
                  <td
                    v-if="
                      dataProps.data.header.InvoiceType != 'FEX' &&
                      dataProps.data.header.InvoiceType != 'CDD'
                    "
                    style="
                      border-left: 1px solid;
                      border-right: 1px solid;
                      text-align: right;
                      padding: 5px;
                    "
                  >
                    {{ formatWithCommas(parseFloat(row.ItemNoSuj).toFixed(2)) }}
                  </td>
                  <td
                    v-if="dataProps.data.header.InvoiceType == 'FEX'"
                    style="
                      border-left: 1px solid;
                      border-right: 1px solid;
                      text-align: right;
                      padding: 5px;
                    "
                  >
                    {{
                      formatWithCommas(parseFloat(row.ItemNoSuj).toFixed(2))
                    }}
                  </td>
                  <td
                    v-if="dataProps.data.header.InvoiceType !== 'FEX'"
                    style="
                      border-left: 1px solid;
                      border-right: 1px solid;
                      text-align: right;
                      padding: 5px;
                    "
                  >
                    {{
                      formatWithCommas(parseFloat(row.ItemGravada).toFixed(2))
                    }}
                  </td>
                  <td
                    v-if="dataProps.data.header.InvoiceType == 'FEX'"
                    style="
                      border-left: 1px solid;
                      border-right: 1px solid;
                      text-align: right;
                      padding: 5px;
                    "
                  >
                    {{ formatWithCommas(parseFloat(row.ItemGravada).toFixed(2)) }}
                  </td>
                </tr>
              </table>
              <!-- Sumas y responsable -->
              <table
                v-if="pIndex + 1 === totalPages"
                style="
                  width: 100% !important;
                  font-size: 11px;
                  border-bottom: 1px solid black;
                  border-left: 1px solid black;
                  border-right: 1px solid black;
                  border-collapse: collapse;
                "
              >
                <colgroup>
                  <col />
                  <col style="width: 70px" />
                  <col style="width: 69px" />
                  <col style="width: 70px" />
                  <col style="width: 70px" />
                  <col
                    v-if="
                      dataProps.data.header.InvoiceType != 'FEX' &&
                      dataProps.data.header.InvoiceType != 'CDD'
                    "
                    style="width: 70px"
                  />
                </colgroup>
                <tr>
                  <td
                    style="
                      border-bottom: 1px solid black;
                      border-right: 1px solid black;
                    "
                    
                  >
                    <b>Valor en letras: </b>
                    {{ dataProps.data.header.InvoiceTotalLetras }}
                  </td>
                  <td style="border-bottom: 1px solid black"><b>Sumas: </b></td>
                  <td
                    style="
                      border-bottom: 1px solid black;
                      border-left: 1px solid black;
                      text-align: right;
                      padding-right: 5px;
                    "
                  >
                    {{
                      formatWithCommas(parseFloat(totals.discount).toFixed(2))
                    }}
                  </td>
                  <td
                    v-if="dataProps.data.header.InvoiceType != 'FEX' &&
                    dataProps.data.header.InvoiceType != 'CDD'"
                    style="
                      border-bottom: 1px solid black;
                      border-left: 1px solid black;
                      text-align: right;
                      padding-right: 5px;
                    "
                  >
                    {{
                      formatWithCommas(parseFloat(totals.exentas).toFixed(2))
                    }}
                  </td>
                  <td
                    style="
                      border-bottom: 1px solid black;
                      border-left: 1px solid black;
                      text-align: right;
                      padding-right: 5px;
                    "
                  >
                    {{
                       formatWithCommas(parseFloat(totals.noSujetas).toFixed(2))
                    }}
                  </td>
                  <td
                    style="
                      border-bottom: 1px solid black;
                      border-left: 1px solid black;
                      text-align: right;
                      padding-right: 5px;
                    "
                  >
                    {{
                       formatWithCommas(parseFloat(totals.gravadas).toFixed(2)) 
                    }}
                  </td>
                </tr>
                <tr>
                  <!-- lado izquierdo responsables-->
                  <td>
                    <table
                      style="
                        width: 100% !important;
                        font-size: 11px;
                        text-align: right;
                        border-collapse: collapse;
                      "
                    >
                      <colgroup>
                        <col style="width: 20%" />
                        <col style="width: 30%" />
                        <col style="width: 20%" />
                        <col style="width: 30%" />
                      </colgroup>
                      <tr style="height: 4em">
                        <td
                          colspan="4"
                          style="
                            text-align: left;
                            border-bottom: 1px solid black;
                            vertical-align: top;
                            border-right: 1px solid black;
                          "
                        >
                          <b>Observación: </b>
                        </td>
                      </tr>
                      <tr>
                        <td
                          colspan="4"
                          style="
                            text-align: left;
                            border-bottom: 1px solid black;
                            border-right: 1px solid black;
                          "
                        >
                          <b>Operacion superior a $11,428.58 </b>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            padding-left: 5px;
                            text-align: left;
                            border-bottom: 1px solid black;
                            border-right: 1px solid black;
                            height: 3em;
                          "
                        >
                          <b>Nombre entrega:</b>
                        </td>
                        <td
                          style="
                            padding-left: 5px;
                            text-align: left;
                            border-bottom: 1px solid black;
                            border-right: 1px solid black;
                            height: 3em;
                          "
                        ></td>
                        <td
                          style="
                            padding-left: 5px;
                            text-align: left;
                            border-bottom: 1px solid black;
                            border-right: 1px solid black;
                            height: 3em;
                          "
                        >
                          <b>No documento:</b>
                        </td>
                        <td
                          style="
                            padding-left: 5px;
                            text-align: left;
                            border-bottom: 1px solid black;
                            border-right: 1px solid black;
                            height: 3em;
                          "
                        ></td>
                      </tr>
                      <tr>
                        <td
                          style="
                            padding-left: 5px;
                            text-align: left;
                            border-right: 1px solid black;
                            height: 3em;
                          "
                        >
                          <b>Nombre recibe:</b>
                        </td>
                        <td
                          style="
                            padding-left: 5px;
                            text-align: left;
                            border-right: 1px solid black;
                            height: 3em;
                          "
                        ></td>
                        <td
                          style="
                            padding-left: 5px;
                            text-align: left;
                            border-right: 1px solid black;
                            height: 3em;
                          "
                        >
                          <b>No documento:</b>
                        </td>
                        <td
                          style="
                            padding-left: 5px;
                            text-align: left;
                            border-right: 1px solid black;
                            height: 3em;
                          "
                        ></td>
                      </tr>
                    </table>
                  </td>
                  <!-- lado derecho sumas detalle -->
                  <td colspan="6">
                    <table
                      style="
                        width: 100% !important;
                        font-size: 11px;
                        text-align: right;
                      "
                    >
                      <template
                        v-if="dataProps.data.header.InvoiceType == 'CCF'"
                      >
                        <tr>
                          <td>Sub total ventas gravadas</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceSubTotalVentas
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <template
                          v-if="
                            ['881d5e798910450e5a8c35a4b379a3e9'].includes(
                              keyMaster
                            )
                          "
                        >
                          <tr>
                            <td>Ventas exentas</td>
                            <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                            <td style="text-align: right; width: 50px">
                              {{
                                formatWithCommas(
                                  parseFloat(
                                    dataProps.data.header.InvoiceTotalExenta
                                  ).toFixed(2)
                                )
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td>Ventas no sujetas</td>
                            <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                            <td style="text-align: right; width: 50px">
                              {{
                                formatWithCommas(
                                  parseFloat(
                                    dataProps.data.header.InvoiceTotalNoSuj
                                  ).toFixed(2)
                                )
                              }}
                            </td>
                          </tr>
                        </template>
                        <tr>
                          <td>Total descuentos</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceTotalDescu
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr
                          v-if="
                            parseFloat(
                              dataProps.data.header.TurismoPorAlojamiento
                            ) > 0
                          "
                        >
                          <td>Imp. turismo</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.TurismoPorAlojamiento
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>IVA</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceTotalIva
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Sub total</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header
                                    .InvoiceMontoTotalOperacion
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>IVA Retenido</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceIvaRete1
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>IVA Percibido</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceIvaPerce1
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Impuesto sobre la renta</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceReteRenta
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr v-if="parseFloat(dataProps.data.header.Fovial) > 0">
                          <td>Fovial</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.Fovial
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr
                          v-if="parseFloat(dataProps.data.header.Cotrans) > 0"
                        >
                          <td>Cotrans</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.Cotrans
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr style="font-size: 12px">
                          <td><b>Total</b></td>
                          <td>
                            <b>{{ dataProps.data.header.InvoiceCurrency }}</b>
                          </td>
                          <td style="text-align: right; width: 50px">
                            <b>{{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceTotalPagar
                                ).toFixed(2)
                              )
                            }}</b>
                          </td>
                        </tr>
                      </template>

                      <template
                        v-if="
                          dataProps.data.header.InvoiceType == 'FCF' ||
                          dataProps.data.header.InvoiceType == 'DNR'
                        "
                      >
                        <tr>
                          <td>Sub total de ventas</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceSubTotalVentas
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <template
                          v-if="
                            ['881d5e798910450e5a8c35a4b379a3e9'].includes(
                              keyMaster
                            )
                          "
                        >
                          <tr>
                            <td>Ventas exentas</td>
                            <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                            <td style="text-align: right; width: 50px">
                              {{
                                formatWithCommas(
                                  parseFloat(
                                    dataProps.data.header.InvoiceTotalExenta
                                  ).toFixed(2)
                                )
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td>Ventas no sujetas</td>
                            <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                            <td style="text-align: right; width: 50px">
                              {{
                                formatWithCommas(
                                  parseFloat(
                                    dataProps.data.header.InvoiceTotalNoSuj
                                  ).toFixed(2)
                                )
                              }}
                            </td>
                          </tr>
                        </template>
                        <tr>
                          <td>Total descuentos</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceTotalDescu
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr
                          v-if="
                            parseFloat(
                              dataProps.data.header.TurismoPorAlojamiento
                            ) > 0
                          "
                        >
                          <td>Imp. turismo</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.TurismoPorAlojamiento
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>IVA Retenido</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceIvaRete1
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Impuesto sobre la renta</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceReteRenta
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr v-if="parseFloat(dataProps.data.header.Fovial) > 0">
                          <td>Fovial</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.Fovial
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr
                          v-if="parseFloat(dataProps.data.header.Cotrans) > 0"
                        >
                          <td>Cotrans</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.Cotrans
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr style="font-size: 12px">
                          <td><b>Total</b></td>
                          <td>
                            <b>{{ dataProps.data.header.InvoiceCurrency }}</b>
                          </td>
                          <td style="text-align: right; width: 50px">
                            <b>{{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceTotalPagar
                                ).toFixed(2)
                              )
                            }}</b>
                          </td>
                        </tr>
                      </template>

                      <template
                        v-if="dataProps.data.header.InvoiceType == 'CDD'"
                      >
                        <tr style="font-size: 12px">
                          <td><b>Total de la donación</b></td>

                          <td style="text-align: right; width: 80px">
                            <b
                              >{{ dataProps.data.header.InvoiceCurrency }}
                              {{
                                formatWithCommas(
                                  parseFloat(
                                    dataProps.data.header.InvoiceTotalPagar
                                  ).toFixed(2)
                                )
                              }}</b
                            >
                          </td>
                        </tr>
                      </template>

                      <template
                        v-if="dataProps.data.header.InvoiceType == 'FEX'"
                      >
                        <tr>
                          <td>Total de Operaciones Afectas</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceSubTotalVentas
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Monto global de Desc., Rebajas de operaciones
                            afectas
                          </td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceTotalDescu
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr v-if="dataProps.data.header.InvoiceType === 'FEX'">
                          <td>Flete</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(dataProps.data.header.Flete).toFixed(
                                  2
                                )
                              )
                            }}
                          </td>
                        </tr>
                        <tr v-if="dataProps.data.header.InvoiceType === 'FEX'">
                          <td>Seguro</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.Seguro
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr style="font-size: 12px">
                          <td><b>Monto Total de la Operación</b></td>
                          <td>
                            <b>{{ dataProps.data.header.InvoiceCurrency }}</b>
                          </td>
                          <td style="text-align: right; width: 50px">
                            <b>{{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceTotalPagar
                                ).toFixed(2)
                              )
                            }}</b>
                          </td>
                        </tr>
                      </template>

                      <template
                        v-if="dataProps.data.header.InvoiceType == 'FNS'"
                      >
                        <tr>
                          <td>Sub total de ventas</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceSubTotalVentas
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <template
                          v-if="
                            ['881d5e798910450e5a8c35a4b379a3e9'].includes(
                              keyMaster
                            )
                          "
                        >
                          <tr>
                            <td>Ventas exentas</td>
                            <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                            <td style="text-align: right; width: 50px">
                              {{
                                formatWithCommas(
                                  parseFloat(
                                    dataProps.data.header.InvoiceTotalExenta
                                  ).toFixed(2)
                                )
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td>Ventas no sujetas</td>
                            <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                            <td style="text-align: right; width: 50px">
                              {{
                                formatWithCommas(
                                  parseFloat(
                                    dataProps.data.header.InvoiceTotalNoSuj
                                  ).toFixed(2)
                                )
                              }}
                            </td>
                          </tr>
                        </template>
                        <tr>
                          <td>Total descuentos</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceTotalDescu
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>IVA Retenido</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceIvaRete1
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Impuesto sobre la renta</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceReteRenta
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr v-if="dataProps.data.header.InvoiceType === 'FEX'">
                          <td>Flete</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(dataProps.data.header.Flete).toFixed(
                                  2
                                )
                              )
                            }}
                          </td>
                        </tr>
                        <tr v-if="dataProps.data.header.InvoiceType === 'FEX'">
                          <td>Seguro</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.Seguro
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr style="font-size: 12px">
                          <td><b>Total</b></td>
                          <td>
                            <b>{{ dataProps.data.header.InvoiceCurrency }}</b>
                          </td>
                          <td style="text-align: right; width: 50px">
                            <b>{{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceTotalPagar
                                ).toFixed(2)
                              )
                            }}</b>
                          </td>
                        </tr>
                      </template>

                      <template
                        v-if="
                          dataProps.data.header.InvoiceType == 'DNC' ||
                          dataProps.data.header.InvoiceType == 'DND'
                        "
                      >
                        <tr>
                          <td>Sub total de ventas</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceSubTotalVentas
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Monto global Des., Rebajas y otros a ventas no
                            sujetas
                          </td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceDescuNoSuj
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Monto global Des., Rebajas y otros a ventas exentas
                          </td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceDescuExenta
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Monto global Des., Rebajas y otros a ventas gravadas
                          </td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceDescuGravada
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr
                          v-if="
                            parseFloat(
                              dataProps.data.header.TurismoPorAlojamiento
                            ) > 0
                          "
                        >
                          <td>Imp. turismo</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.TurismoPorAlojamiento
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Impuesto al Valor Agregado 13%</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceTotalIva
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>IVA Retenido</td>
                          <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                          <td style="text-align: right; width: 50px">
                            {{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceIvaRete1
                                ).toFixed(2)
                              )
                            }}
                          </td>
                        </tr>
                        <tr style="font-size: 12px">
                          <td><b>Total</b></td>
                          <td>
                            <b>{{ dataProps.data.header.InvoiceCurrency }}</b>
                          </td>
                          <td style="text-align: right; width: 50px">
                            <b>{{
                              formatWithCommas(
                                parseFloat(
                                  dataProps.data.header.InvoiceTotalPagar
                                ).toFixed(2)
                              )
                            }}</b>
                          </td>
                        </tr>
                      </template>
                    </table>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <!-- page footer -->
          <template #footer>
            <p style="font-size: 10px">
              Pagina {{ pIndex + 1 }} de {{ totalPages }}
            </p>
          </template>
        </preview-page>
      </template>
    </preview-document>
  </window-portal>
</template>

<script>
import DownloadInvalidationJson from "@/components/ReportsAndPrintings/DownloadInvalidationJson.vue";
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue";
import PreviewDocument from "@/components/PreviewDocument/PreviewDocument.vue";
import PreviewPage from "@/components/PreviewDocument/PreviewPage.vue";
import QRCode from "qrcode";
import { numberWithCommas } from "../../helpers/money";

export default {
  name: "PrintPosFaCiade",

  model: {
    event: "update",
    prop: "show",
  },

  props: {
    dataProps: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
    hideQr: {
      type: Boolean,
      default: false,
    },
  },

  components: { DownloadInvalidationJson, WindowPortal, PreviewDocument, PreviewPage },

  data: () => ({
    pagesData: [[]],
    previewConfig: {
      title: "Vista Previa de Impresión de Factura Electrónica",
      filename: "Factura Electronica.pdf",
      margins: [10, 10, 10, 10],
      unit: "mm",
      format: "letter",
      orientation: "portrait",
    },
    totals: {
      discount: 0,
      exentas: 0,
      noSujetas: 0,
      gravadas: 0,
    },
    maxRowsPerPage: 6,
    imageOpacity: "",
    urlQr: null,
    specialinvoicescolor: JSON.parse(localStorage.getItem("user"))
      .specialinvoicescolor,
    specialInvoicesTitleColor: JSON.parse(localStorage.getItem("user"))
      .specialInvoicesTitleColor,
    kitcoalternativeposclientdata: JSON.parse(localStorage.getItem("user"))
      .kitcoalternativeposclientdata,
    lexlitislatamclientdata: JSON.parse(localStorage.getItem("user"))
      .lexlitislatamclientdata,
    romerolascascadasdata: JSON.parse(localStorage.getItem("user"))
      .romerolascascadasdata,
    keyMaster: JSON.parse(localStorage.getItem("user")).keymaster,
    ShowCorrelativeControl: JSON.parse(localStorage.getItem("user"))
      .showcorrelativecontrol,
    posshowprincipalbarcode: JSON.parse(localStorage.getItem("user"))
      .posshowprincipalbarcode,
    mailLabel:null
  }),
  computed: {
    totalPages() {
      return this.pagesData.length;
    },
    modifiedBranchBilledInfo() {
      const info = this.dataProps.data.branch.BranchBilledInfo;
      if (info) {
        return info.replace(/<p>/g, "").replace(/<\/p>/g, "<br/>");
      }

      return null;
    },
    colorTable() {
      if (this.keyMaster === "3f3355bdc105555f5c6fe11bfd1e5021") {
        if (this.dataProps.data.header.ID_Branch === "109") {
          return { bg: "#A3BD31", fg: "#000000" };
        } else if (this.dataProps.data.header.ID_Branch === "115") {
          return { bg: "#be0811", fg: "white" };
        }
      }

      if (this.specialinvoicescolor) {
        return {
          bg: this.specialinvoicescolor,
          fg: this.specialInvoicesTitleColor || "white",
        };
      } else {
        return { bg: "grey", fg: "black" };
      }
    },
    dateWithDays() {
      let fecha = this.dataProps.data.header.InvoiceDate;
      let dias = this.dataProps.data.header.InvoiceCreditDay;

      const partesFecha = fecha.split("/");
      const dia = parseInt(partesFecha[0], 10);
      const mes = parseInt(partesFecha[1], 10) - 1;
      const anio = parseInt(partesFecha[2], 10);
      const fechaInicial = new Date(anio, mes, dia);

      const diasAgregar = parseInt(dias.split(" ")[0], 10);

      fechaInicial.setDate(fechaInicial.getDate() + diasAgregar);

      const diaNuevo = ("0" + fechaInicial.getDate()).slice(-2);
      const mesNuevo = ("0" + (fechaInicial.getMonth() + 1)).slice(-2);
      const anioNuevo = fechaInicial.getFullYear();

      return `${diaNuevo}/${mesNuevo}/${anioNuevo}`;
    },
  },
  watch: {
    async show(value) {
      if (value) {
        await this.getImages();
        this.getQr();
        this.calculatePages();
      }
    },
  },
  methods: {
    onClose() {
      this.$emit("update", false);
    },
    getCurrentPage(nextRecords = 1) {
      const page = this.pagesData[this.pagesData.length - 1];
      if (page.length + nextRecords <= this.maxRowsPerPage) {
        return page;
      } else {
        this.pagesData.push([]);
        return this.pagesData[this.pagesData.length - 1];
      }
    },
    calculatePages() {
      let index = 1;
      this.pagesData = [[]];
      this.totals = {
        discount: 0,
        exentas: 0,
        noSujetas: 0,
        gravadas: 0,
      };
      for (const item of this.dataProps.data.body) {
        const page = this.getCurrentPage();
        page.push({ ...item, index, itemType: 3, venAfectas: 0, otroMonto: 0 });
        this.totals.discount += item.ItemDiscount;
        this.totals.exentas += item.ItemExenta;
        this.totals.noSujetas += item.ItemNoSuj;
        this.totals.gravadas += item.ItemGravada;
        index++;
      }
      const page = this.getCurrentPage();
      for (let i = page.length; i < this.maxRowsPerPage - 8; i++) {
        page.push({ index: "&nbsp;" });
      }
    },
    getQr() {
      const partes = this.dataProps.data.header.InvoiceDate.split("/");
      const dia = partes[0];
      const mes = partes[1];
      const anio = partes[2];

      const fechaNueva = `${anio}-${mes}-${dia}`;
      const url =
        this.dataProps.data.branch.AuthFeMode == 1
          ? `https://admin.factura.gob.sv/consultaPublica?ambiente=01&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`
          : `https://admin.factura.gob.sv/consultaPublica?ambiente=00&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`;

      const opt = {
        errorCorrectionLevel: "H",
        type: "image/png",
        quality: 0.3,
        margin: 1,
        color: {
          dark: "#000000",
          light: "#ffffff",
        },
        width: 100,
      };

      QRCode.toDataURL(url, opt, (error, url) => {
        if (error) {
          console.log("Error al generar el código QR:", error);
          throw error;
        }

        this.urlQr = url;
      });
    },
    formatWithCommas(x) {
      if (isNaN(x)) {
        return "";
      }
      return numberWithCommas(x);
    },
    async getImages() {
      const logoMarcaAguaNutre =
        "https://innova-apps.sfo3.digitaloceanspaces.com/NutreOpacity.png";
      const logoMarcaAguaJR =
        "https://storageinnovaapps.innovatebusiness.org/Logo%20transparencia%20JR.png";

      const img = this.dataProps.data.branch.BranchBannerPath;
      const logo = this.dataProps.data.branch.BranchLogoPath;

      if (logo) {
        const LogoBranchBase64 = localStorage.getItem("LogoBranchBase64")

        if (LogoBranchBase64) {
          this.dataProps.data.branch.BranchLogoPath = `${LogoBranchBase64}`;
        }
        else {
          const { imageBase64: logoImageBase64 } = await this.$API.utilities.getImageInBase64({ file: logo });
          this.dataProps.data.branch.BranchLogoPath = `${logoImageBase64}`;
        }
      }

      if (img) {
        const { imageBase64: bannerImageBase64 } =
          await this.$API.utilities.getImageInBase64({ file: img });
        this.dataProps.data.branch.BranchBannerPath = `${bannerImageBase64}`;
      }

      if (this.keyMaster === "70c2d9e69a0b2f0320af142fb4539de4") {
        const { imageBase64: opacityBase64 } =
          await this.$API.utilities.getImageInBase64({ file: logoMarcaAguaJR });
        this.imageOpacity = `${opacityBase64}`;
      } else if (this.keyMaster === "d43fceb7471678deea175915cd0bb56d") {
        const { imageBase64: opacityBase64 } =
          await this.$API.utilities.getImageInBase64({
            file: logoMarcaAguaNutre,
          });
        this.imageOpacity = `${opacityBase64}`;
      }
    },
    assignCuerpoDocumento() {
      this.dataProps.data.header.jsonMH.cuerpoDocumento =
        this.dataProps.data.body.map((item, index) => ({
          descripcion: item.ItemDescription,
          montoDescu: item.ItemDiscount,
          codigo: item.ID_Item,
          ventaGravada: item.ItemGravada,
          ivaItem: item.ItemIva,
          ventaNoSuj: item.ItemNoSuj,
          ventaExenta: item.ItemExenta,
          numItem: index + 1,
          noGravado: item.ItemNoGravada,
          psv: item.ItemPsv,
          uniMedida: item.ItemMeasureUnit,
          cantidad: item.ItemQuantity,
          precioUni: item.ItemUnitPrice,
        }));
    },
    async downLoadJSON() {
      try {
        const selloRecibido =
          JSON.parse(this.dataProps.data.header.ResponseMhJson)
            ?.selloRecibido || "";
        const firmaElectronica =
          this.dataProps.data.header.JsonMhSigned?.documento || "";
        const dteJson =
          this.dataProps.data.header.JsonMh.dteJson ??
          this.dataProps.data.dteJson.JsonMh.dteJson;
        const jsonToSend = { ...dteJson, firmaElectronica, selloRecibido };
        delete jsonToSend.passwordPri;

        const aElement = document.createElement("a");
        aElement.setAttribute(
          "download",
          this.dataProps.data.header.ID_Invoice +
            "_" +
            this.dataProps.data.header.InvoiceDate.replaceAll("/", "-") +
            "_" +
            this.dataProps.data.header.InvoiceName.replaceAll(
              /[:/<>*|/]/g,
              ""
            ).replaceAll('\\"', "") +
            ".pdf"
        );
        this.assignCuerpoDocumento();
        const blob = new Blob([JSON.stringify(jsonToSend)], {
          type: "application/json",
        });
        const href = URL.createObjectURL(blob);
        aElement.href = href;
        aElement.download =
          this.dataProps.data.header.ID_Invoice +
          "_" +
          this.dataProps.data.header.InvoiceDate.replaceAll("/", "-") +
          "_" +
          this.dataProps.data.header.InvoiceName.replaceAll(
            /[:/<>*|/]/g,
            ""
          ).replaceAll('\\"', "") +
          ".json";
        aElement.click();
        URL.revokeObjectURL(href);
      } catch (error) {
        this.mailLabel = "Ocurrió un error al descargar JSON";
        console.log(error);
      }
    },
    async sendEmail(doc) {
      try {
        const {
          data: {
            header: { jsonMH, InvoiceDate, InvoiceName },
            dteJson: { ID_Invoice },
          },
        } = this.dataProps;

        const body = {
          dtefilebuffer: new Buffer.from(doc.output("arraybuffer")),
          dtejson: { ...jsonMH, ID_Invoice },
          dtefilebufferfilename:
            ID_Invoice +
            "_" +
            InvoiceDate.replaceAll("/", "-") +
            "_" +
            InvoiceName.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"', ""),
        };
        this.mailLabel = 'Enviando correo...' 
        await this.$API.invoices.sendInvoiceMail(body);

        this.mailLabel = "Se envió el correo correctamente";
        this.$emit("mailSent");
      } catch (error) {
        this.mailLabel = `Ocurrió el siguiente error al enviar el correo ${error}`;
      }
    },
  },
};
</script>